import { combineReducers } from 'redux';

import commonReducer from './common';

export default function createReducer(asyncReducers) {
    return combineReducers({
        common: commonReducer,
        ...asyncReducers
    });
}